<template>
	<div>

		<h1 v-if="node_workflow && node_workflow.description">{{node_workflow.description}}</h1>
		<h1 v-else>Etape</h1>

		<p v-if="node_workflow && node_workflow.long_description">{{ node_workflow.long_description }}</p>

        <b-select :options="options" v-model="action_step"/>

        <step 
			v-if="action_step"
            ref="step"
            :workflow="true"
			@test="test"
			:id="'step-' + id"
			:action_id="'action-' + id"
        />

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
	</div>
</template>

<script>
	var clone = require("clone");
	import uniqueId from "lodash.uniqueid";
	
    import step from "../components/Step.vue";
	import workers from "../services/workers.js";
	import treatments from "../services/treatments.js";
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	export default {
		name: "step_workflow",
		components: {
            step,
			FadeLoader
		},
		data() {
			return {
                options: [
					//{ text: "Airtable", value: "airtable" },
					//{ text: "Api", value: "api" },
					//{ text: "Base de données", value: "base de données" },
					//{ text: "ChatGPT", value: "chatgpt_v2" },
					//{ text: "Correspondance", value: "correspondance_v2" },
					//{ text: "Envoi de mail", value: "mail" },
					{ text: "Fonctions excel", value: "fonctions excel" },
					{ text: "Fonctions sur colonne", value: "opérations sur colonnes" },
					{ text: "Mapping", value: "mapping" },
					{ text: "Normalisation", value: "nettoyage" },
					//{ text: "Perplexity", value: "perplexity" },
					{ text: "Script personnalisé", value: "fonction" },
					{ text: "Tri", value: "sort" },
					{ text: "Split json", value: "split_json" },
    				{ text: "Supprimer lignes", value: "supprimer lignes" },
					//{ text: "Traduction", value: "translate" },
					//{ text: "XLSX", value: "xlsx" },
					//{ text: "Zip", value: "zip" },
                ],
                action_step: "",
				id: uniqueId(""),
				spinner: false
			};
		},
		props: {
			node_workflow: {
				default: () =>  null
			},
			worflow_builder: {
				default: false
			},
            workflow: {
                default: null
            }
        },
        watch: {
            action_step: {
				handler: async function (newVal, oldVal) {

					await this.$nextTick();

					this.$refs.step.setAction(this.action_step);
				}
			}
        },
		methods: {
			async save_workflow()
			{
				var data = {
					step: this.$refs.step.save(),
					action_step: this.action_step
                };

				return data;
			},
			async load_workflow(data)
			{
				this.action_step = data.action_step;

				await this.$nextTick();

				if (this.$refs.step)
					await this.$refs.step.load(data.step)
			},
            async get_data_in()
            {
			},
            async get_data_out()
            {
				if (this.$refs.step)
				{
					var data = this.$refs.step.getUrls();
					var files = await this.$refs.step.get_data_files(true);

					data = data.concat(files);

					return data;
				}
				else
					return [];
			},
			async test(
				step,
				id,
				data
			) {
				this.spinner = true;

				step.setResults(
					[],
					null,
					[],
					[],
					"",
					null,
					null,
					[]
				);

				var formData = new FormData();
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != "uid")
						formData.set(
							keys[i],
							typeof data[keys[i]] === "object"
								? JSON.stringify(data[keys[i]])
								: data[keys[i]]
						);
				}

				var data = await this.$parent.get_data_in(this.workflow);
				var url_files = [];

				for (var i = 0; i < data.length; i++)
				{
					if (data[i].type == "csv")
					{
						formData.append(data[i].name, data[i].data);
					}
					else if (data[i] instanceof File)
					{
						formData.append(data[i].name || data[i].upload.filename, data[i]);
					}
					else
					{
						url_files.push({
							url: data[i].url,
							name: data[i].name
						})
					}
				}

				if (url_files.length > 0)
					formData.set("url_files", JSON.stringify(url_files));

				let results = await workers.test(formData);
				var urls = []

				var all_files = results.data.files;
				if (!all_files || all_files.length == 0) all_files = [];
					all_files.sort((a, b) => (a.name > b.name ? 1 : -1));

				var csv = [];
				var name_file = "data.csv";

				var first_csv = true;
				for (var i = 0; i < all_files.length; i++) {
					if (
						first_csv &&
						all_files[i].name.endsWith(".csv") &&
						!step.file_result
					) {
						var csv_data = await treatments.getFileAlyx(
							all_files[i].url,
							false,
							false
						);
						name_file = all_files[i].name;
						csv = this.$papa.parse(csv_data, {
							header: true,
						});
						csv = csv.data;
						var first_csv = false;
					} else {
						//console.log("other type file");
						urls.push({
							name: all_files[i].name,
							url: all_files[i].url,
						});
					}
					
				}

				step.setResults(
					csv,
					null,
					[],
					[],
					name_file,
					null,
					null,
					urls
				);

				this.spinner = false;
			}
		},
		mounted: async function () {
		},
	};
</script>


<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}
</style>